<template>
    <el-dialog id="csvTable"
        :title="importTitle" 
        :visible.sync="importDialog"
        :before-close="handleClose">
        <span v-show="csvFile.length === 0" class="choose-hint">僅接受 csv 格式的檔案</span>
        <input v-show="false" type="file" name="File Upload" ref="csvFile" accept=".csv" v-on:change="handleFilesUpload()"/>
        <el-button v-show="csvFile.length === 0" class="choose-btn" @click="chooseCSV">選擇檔案</el-button>
        <!-- CSV table -->
        <el-table v-if="!importStart && csvFile && csvFile.length > 0"
            :data="csvFile" empty-text="暫無資料" style="width: 100%">
            <el-table-column label="Name" min-width="90">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.name">
                    <span slot="content">{{row.name}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Password" min-width="100">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.password">
                    <span slot="content">{{row.password}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Displayname" min-width="90">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.displayName">
                    <span slot="content">{{row.displayName}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Email" min-width="150">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.email">
                    <span slot="content">{{row.email}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Level" min-width="100">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.level"
                    editable-component="el-select" align="center" close-event="change">	
                    <el-tag size="medium" slot="content">
                        {{formatLevel(row)}}
                    </el-tag>
                    <template slot="edit-component-slot">
                        <el-option value="1" label="Level 1"></el-option>
                        <el-option value="2" label="Level 2"></el-option>
                        <el-option value="3" label="Level 3"></el-option>
                    </template>
                </editable-cell>
            </el-table-column>
            <el-table-column v-if="$store.state.isSystemAdminMode" label="Department" min-width="120">
                <el-cascader placeholder="請選擇"
                        slot-scope="{row}" 
                        v-model="row.selectedDepId"
                        :show-all-levels="false"
                        :options="actualDepsOptions">
                </el-cascader>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <a v-show="csvFile.length === 0" class="download-hint" 
                    href="./static/Import_User_Sample.csv" 
                    download="Import_User_Sample.csv">不知道格式如何填寫 ? 下載匯入帳號 csv 文件範本
            </a>
            <div v-show="!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
                    class="csv-hint">載入csv後中文字出現亂碼嗎 ? 請點擊「UTF8編碼轉換」按鈕後再繼續執行編輯動作或參閱
            </div>
            <a v-show="!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
                    class="download-csv-hint"
                    href="./static/CSV_UTF8_Format.pdf"
                    download="CSV_UTF8_Format.pdf">csv格式轉檔說明
            </a>	
            <div v-show="!importStart && csvFile && csvFile.length > 0" class="btn-area">
                <el-button class="import-btn" @click="importCSV">
                    確定匯入
                </el-button>
                <el-button class="renew-btn" @click="chooseCSV">
                    重新選擇
                </el-button>
                <el-button v-show="!csvTrasfer" class="utf8-btn" @click="utf8CSV">
                    UTF8編碼轉換
                </el-button>
                <el-button v-show="csvTrasfer" class="utf8-btn" @click="big5CSV">
                    BIG5編碼轉換
                </el-button>
            </div>
            <el-progress v-show="importStart" :percentage="importPercent"></el-progress>
        </span>
    </el-dialog>
</template>

<script>
import API from '../../api/api';
import EditableCell from "./EditeableCell.vue";
export default {
    name: 'AccountImport',
    components: {
        EditableCell,
    },
    props: {
        actualDepsOptions: {
            type: Array
        },
        importCsvName: {
            type: String
        },
        importCsvArray: {
            type: Array
        },
    },
    data() {
        return {
            importDialog: false,
            csvFile: [],
            importTitle: "匯入帳號",
            importPercent: 0,
            importStart: false,
            csvTrasfer: false,
            sourceRef: null
        }
    },
    methods: {
        startImport() {
            this.importDialog = true;
            this.csvFile.splice(0);
            this.csvFile = this.importCsvArray;
            this.updateDialog();
        },
        updateDialog() {
            if (this.csvFile && this.csvFile.length > 0 ) {
                this.importTitle = "匯入帳號" + " - 成功載入 " + this.csvFile.length  + " 筆資料 (" + this.importCsvName + ")";
                document.getElementById('csvTable').children[0].style.width = "1024px";
            } else {
                this.$emit("showHint", '匯入帳號 CSV 裡沒有資料，請重新選擇檔案進行匯入!');
                this.importTitle = "匯入帳號";
                document.getElementById('csvTable').children[0].style.width = "520px";
                $('input[type="file"]').val(null);
            }
        },
        handleClose: function() {
            this.$confirm('確定結束匯入動作嗎 ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.setImportantProgress(0, "匯入帳號", false);
                this.importDialog = false;
                $('input[type="file"]').val(null);
                this.csvFile = [];
            }).catch(() => {

            });
        },
        setImportantProgress: function(percent, title, isGoing) {
            this.importPercent = percent;
            this.importTitle = title;
            this.importStart = isGoing;
        },
        handleFilesUpload: function() {
            this.csvTrasfer = false;
            if(this.$refs.csvFile.files[0]) {
                this.sourceRef = this.$refs.csvFile.files[0];
                this.fileReader(false, this.sourceRef);
            } 
        },
        chooseCSV: function(evt) {
            this.$refs.csvFile.click();
        },
        utf8CSV: function(evt) {
            this.$confirm('將以一開始載入的資料作轉換，確定要繼續轉換？ ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.fileReader(true, this.sourceRef);
            }).catch(() => {

            });
        },
        big5CSV: function(evt) {
            this.$confirm('將以一開始載入的資料作轉換，確定要繼續轉換？ ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.fileReader(false, this.sourceRef);
            }).catch(() => {

            });
        },
        fileReader: function(utf8, file) {
            var reader = new FileReader();
            let that = this;
    
            if(utf8) {
                reader.readAsText(file);
                that.csvTrasfer = true;
            } else {
                reader.readAsText(file, 'big5');
                that.csvTrasfer = false;
            }
            
            reader.onload = function(event) {
                //為了應付IE11 big5 transcode
                let transferResult = event.target.result.replace(event.target.result.split(',')[0], 'name');

                //讀入所匯入的CSV格式
                that.csvFile = window.jQuery.csv.toObjects(transferResult);
        
                //代表使用者沒有自訂欄位,那就照順序填入
                if(that.csvFile.length > 0 && that.csvFile[0].hasOwnProperty('name') === false) {
                    for(var i = 0 ; i < that.csvFile.length ; i++) {
                        that.csvFile[i].name = that.csvFile[i][Object.getOwnPropertyNames(that.csvFile[i])[0]];
                        that.csvFile[i].password = that.csvFile[i][Object.getOwnPropertyNames(that.csvFile[i])[1]];
                        that.csvFile[i].displayName = that.csvFile[i][Object.getOwnPropertyNames(that.csvFile[i])[2]];
                        that.csvFile[i].email = that.csvFile[i][Object.getOwnPropertyNames(that.csvFile[i])[3]];
                        that.csvFile[i].level = that.csvFile[i][Object.getOwnPropertyNames(that.csvFile[i])[4]];
                    }
                }

                if(that.$store.state.isSystemAdminMode) {
                    for(var i = 0 ; i < that.csvFile.length ; i++) {
                        that.csvFile[i].selectedDepId = that.$store.state.accountList.selectedDepId;
                        that.csvFile[i].isManager = 0;
                        that.csvFile[i].status = 1;
                    }
                } else {
                    for(var i = 0 ; i < that.csvFile.length ; i++) {
                        that.csvFile[i].selectedDepId = [that.$store.state.userDepId, that.$store.state.userActualDepId];
                        that.csvFile[i].isManager = 0;
                        that.csvFile[i].status = 1;
                    }
                }
                
                //CSV基本防呆判斷
                if (that.csvFile && that.csvFile.length > 0 ) {
                    that.importTitle = "匯入帳號" + " - 成功載入 " + that.csvFile.length  + " 筆資料 (" + file.name + ")";
                    document.getElementById('csvTable').children[0].style.width = "1024px";
                } else {
                    that.$emit("showHint", '匯入帳號 CSV 裡沒有資料，請重新選擇檔案進行匯入!');
                    that.importTitle = "匯入帳號";
                    document.getElementById('csvTable').children[0].style.width = "520px";
                    $('input[type="file"]').val(null);
                }
            };
    
            reader.onerror = function() {
                that.$emit("showHint", '匯入帳號 CSV 錯誤!');
            };
        },
        importCSV: function(evt) {
            let that = this;
            if(that.$store.state.isSystemAdminMode) {
                let checkDepError = false;
                for(var i = 0 ; i < that.csvFile.length ; i++) {
                    if(that.csvFile[i].selectedDepId === null || that.csvFile[i].selectedDepId.length < 2) {
                        checkDepError = true;
                    }
                }

                if(checkDepError) {
                    this.$emit("showHint", '請確認會員部門都已選擇');
                    return;
                }
            }

            that.setImportantProgress(0, "匯入帳號 - 匯入中...", true);

            let promises = [];
            let error = [];
            let counter = 0;

            for(let i = 0 ; i < that.csvFile.length ; i++) {
                promises.push(new Promise((resolve, reject) => {
                    that.csvFile[i].depId = that.csvFile[i].selectedDepId[0];
                    that.csvFile[i].actual_depid = that.csvFile[i].selectedDepId[1];
                    that.csvFile[i].included = 1;
                    API.addAccount(that.csvFile[i]).then((response) => {
                        if(response.status) {
                            that.setImportantProgress(Math.floor(100 / (that.csvFile.length) * (counter+1)), 
                                                                                "匯入帳號 - 匯入中...", 
                                                                                true);
                            error.push(that.csvFile[i].name);
                            counter++;
                            that.$emit("showHint", JSON.parse(response.request.response).error_msg);
                            resolve(response);
                        } else {
                            that.setImportantProgress(Math.floor(100 / (that.csvFile.length) * (counter+1)), 
                                                                                "匯入帳號 - 匯入中...", 
                                                                                true);
                            counter++;
                            resolve(response);	
                        }
                    });
                }))
            }

            Promise.all(promises).then((res) => {
                if(error.length > 0) {
                    let hint = '';
                    for(let i = 0 ; i < error.length ; i++) {
                        hint += error[i] + '  '
                    }
                    that.importTitle = "匯入帳號 - 匯入完成（注意: 帳號 " +  hint + " 匯入失敗)";
                } else {
                    that.importTitle = "匯入帳號 - 匯入完成（請關閉視窗)";
                }
                that.$emit("getAccounts");
            });
        },
        formatLevel: function (row, column) {
            return 'Level ' + row.level;
        },
    },
}
</script>
<style lang="scss">
    .choose-hint {
        display: block;
        width: 100%;
        float: left;
    }
    .download-hint {
        display: block;
        float: left;
        color: #2E90F4;
        border-bottom: 1px solid #42A0FF;
        margin-bottom: 25px;
        cursor: pointer;
    }
    .csv-hint {
        display: block;
        float: left;
        color: #2E90F4;
        margin-bottom: 25px;
    }
    .download-csv-hint {
        display: block;
        float: left;
        color:red;
        border-bottom: 1px solid red;
        margin-bottom: 25px;
        cursor: pointer;
    }
    .download-csv-hint:hover {
        color:red;
    }

    .choose-btn {
		display: block;
		background: #fff;
		border-radius: 2px;
		color: #2E90F4;
		font-size: 14px;
		height: 36px;
		margin-top: 30px;
		border: 1px solid #2E90F4;
		width: 92px;
	}	
	.choose-btn:hover {
		border: 1px solid #42A0FF;
	}

	.btn-area {
		display: block;
		float: right;
		.renew-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin: 20px 20px 20px 20px;
			border: 1px solid #2E90F4;
			width: 92px;	
		}
		.renew-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
		.utf8-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin: 20px 0px 20px 20px;
			border: 1px solid #2E90F4;
			width: 122px;	
		}
		.utf8-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
		.import-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin-top: 20px;
			border: 1px solid #2E90F4;
			width: 92px;	
		}
		.import-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
	}
</style>


// WEBPACK FOOTER //
// AccountImport.vue?3dc77dec